module.exports = __webpack_public_path__ + "571be9b28c5b745953d107cb92600298.fbx";